import { env } from '../../__config__/env';

export const ValidUrlInput = (value: string | null | undefined): boolean => {
  if (value && value?.trim()?.length > 0) {
    const rgx = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w\- .\/?%&=]*)?/g;
    return rgx.test(value.trim());
  }

  return true;
};

export const IsValidUrl = (value: string | null | undefined): boolean => {
  if (value && value?.trim()?.length > 0) {
    const rgx = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w\- .\/?%&=]*)?/g;
    return rgx.test(value.trim());
  }

  return false;
};

export const isExternalURL = (
  value: string | null | undefined
): { external: boolean; link: string } => {
  let external: boolean = false;
  let link: string = value as string;

  if (value && value?.trim()?.length > 0) {
    const rgx = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w\- .\/?%&=]*)?/g;
    external = rgx.test(value.trim());
  }

  if (!external) {
    if (typeof window !== 'undefined') {
      link = CombineString(window.__ENV__.baseURL, link);
    } else {
      link = CombineString(env.BASE_URL, link);
    }
  }

  return { external, link };
};

const CombineString = (start: string | null | undefined, link: string): string => {
  if (start && link && !link?.trim()?.toLowerCase()?.startsWith(start?.trim()?.toLowerCase())) {
    return start + link;
  }
  return link;
}